let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8x856")).then(() => parcelRequire('Jxc1c'));